import { ehAreaCliente, ehProducao } from "./ambiente";

export function registerGAEvent(data) {
  try {
    const parsedURL = new URL(window.location.href);
    const host = parsedURL.hostname;

    if (!ehProducao() || host !== "app.quitaboletos.com.br") {
      return;
    }

    if (window.gtag) {
      window.gtag("event", "Compra_Completa", {
        nome_cliente: data.name,
        valor_contratado: data.billValue,
      });

      if (data.isNewClient) {
        window.gtag("event", "Compra_Completa_Cliente_Novo", {
          nome_cliente: data.name,
          valor_contratado: data.billValue,
        });
      } else {
        window.gtag("event", "Compra_Completa_Cliente_Recorrente", {
          nome_cliente: data.name,
          valor_contratado: data.billValue,
        });
      }
    }
  } catch (e) {
    console.log(e);
  }
}

export async function getClientIdGoogle() {
  const parsedURL = new URL(window.location.href);
  const host = parsedURL.hostname;

  if (!ehProducao() || host !== "app.quitaboletos.com.br" || !ehAreaCliente()) {
    return;
  }

  if (window.gtag) {
    const clientID = new Promise((resolve) => {
      window.gtag('get', 'G-RC4QR71QPW', 'client_id', function (clientId) {
        resolve(clientId);
      });
    });

    return await clientID
  }
}
